import { MouseEventHandler } from 'react';

import './GifPlayer.css';

type GifPlayerProps = {
  gif: string,
  still: string,
  playing: boolean,
  toggle: MouseEventHandler<HTMLElement>
}
const GifPlayer = ({ gif, still, playing, toggle, ...rest }:GifPlayerProps) => (
  <div
    className={`gif_player ${playing ? ' playing' : ''}`}
    onClick={toggle}
  >
    <div className="play_button" />
    <img {...rest} src={playing ? (gif || still) : (still || gif)} alt="" />
  </div>
);

export default GifPlayer;
